import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from 'Constants/Palette';

export type StatusVariant = 'ok' | 'warn' | 'muted' | 'danger';

const variants: Record<StatusVariant, { background: string; color: string }> = {
  ok: { background: colors.GREEN_ULTRA_LIGHT, color: palette.green },
  warn: { background: '#fcf3dc', color: palette.amber },
  muted: { background: colors.GRAY_TEXT_FIELD, color: palette.muted },
  danger: { background: '#fde3e4', color: colors.RED },
};

export const StatusPill = styled.span<{ variant: StatusVariant; small?: boolean }>`
  display: inline-block;
  padding: ${({ small }) => (small ? '2px 8px' : '4px 12px')};
  border-radius: 999px;
  font-size: ${({ small }) => (small ? '10.5px' : '13px')};
  font-weight: 600;
  white-space: nowrap;
  background: ${({ variant }) => variants[variant].background};
  color: ${({ variant }) => variants[variant].color};
`;
